export interface InsidePage {
  src: string
  alt: string
}

/** The five real interior pages of the product — do not replace with mockups. */
export const insidePages: InsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/hG7mso4E7ws3xWDzZFbjfF/Captura-de-pantalla-2026-09-21-a-la_s_-11.43.58_a.-m..webp',
    alt: 'Interior page: Fuses — find the cause, not just the blown fuse',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/86zofbUsSDYBKVR4JSRfqj/Captura-de-pantalla-2026-09-21-a-la_s_-11.44.11_a.-m..webp',
    alt: 'Interior page: Battery state-of-charge testing',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6HNgPKMHBK8P8Ls4kYsEGr/Captura-de-pantalla-2026-09-21-a-la_s_-11.44.25_a.-m..webp',
    alt: 'Interior page: Starter motor circuit testing',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/m7GqjPigLNgBDEs3cMydm6/Captura-de-pantalla-2026-09-21-a-la_s_-11.44.38_a.-m..webp',
    alt: 'Interior page: Multimeter essentials',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hNxz7pfcWN1wnrdCUnrpx3/Captura-de-pantalla-2026-09-21-a-la_s_-11.44.59_a.-m..webp',
    alt: 'Interior page: Ground faults and connection problems',
  },
]
